import React from 'react';
import {OrbitComponent} from '../../base-components/orbit-component/orbit-component';
import {SeoSectionConfiguration} from '../../../services/configurations/config-data-sections/arenas.configuration';
import {CmsBannerComponent} from '../../cms-banner/cms-banner.component';
import {SeoBreadcrumbsContainerBox} from "./seo-breadcrumbs-container.box";

export interface SeoBreadCrumbsComponentProps {
  arenaName: string;
  config: SeoSectionConfiguration;
}

export class SeoBreadCrumbsComponent extends OrbitComponent<SeoBreadCrumbsComponentProps> {
  render() {
    if(!this.props.config.display || this.services.device.hybrid.isEmbedded) {
      return null;
    }

    return (
      <SeoBreadcrumbsContainerBox className={'cy-seo-breadcrumbs'}>
        <CmsBannerComponent componentID={this.props.config.componentID}
                            templateID={this.props.config.templateID}
                            showPlaceholder={false}/>
      </SeoBreadcrumbsContainerBox>

    )
  }
}
